// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { unsssignDriverFromTrip } from '../../services/TripsService';
import { UnassignDriverFromTripRequest, TripDetails } from '../../types/Trips';

type Result = UseMutationResult<TripDetails, Error, UnassignDriverFromTripRequest>;

function useUnassignDriverFromTrip(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(unsssignDriverFromTrip, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['trip'] });
      queryClient.invalidateQueries({ queryKey: ['trips'] });
      queryClient.invalidateQueries({ queryKey: ['driver'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useUnassignDriverFromTrip;
